import * as React from "react";
import { useMutation, Types } from "@grandvisionhq/graphql";
import { CREATE_RETURN } from "../../operations/mutations/operations/mutations/create-return.js";
import { GET_RETURN } from "../../operations/queries/operations/queries/get-return.js";
const useCreateReturn = ({
  onCompleted,
  onError
} = {}) => {
  const handleOnCompleted = React.useCallback(
    (result) => {
      onCompleted?.(result);
    },
    [onCompleted]
  );
  const [mutation, { called, data, error, loading }] = useMutation(CREATE_RETURN, {
    onCompleted: handleOnCompleted,
    onError(error2) {
      console.error(error2);
      onError?.();
    },
    update(cache, { data: createReturnResponse }) {
      if (createReturnResponse && createReturnResponse.createReturn.return && createReturnResponse.createReturn.failures?.length === 0) {
        cache.writeQuery({
          query: GET_RETURN,
          data: {
            getReturn: {
              ...createReturnResponse?.createReturn,
              __typename: "GetReturnResponse",
              return: {
                ...createReturnResponse?.createReturn?.return,
                status: Types.ReturnStatus.RETURN_REQUESTED
              }
            }
          }
        });
      }
    }
  });
  const trigger = async (input) => {
    return mutation({ variables: { input } });
  };
  return React.useMemo(
    () => [
      trigger,
      {
        called,
        data,
        error,
        loading
      }
    ],
    [trigger, called, data, error, loading]
  );
};
export {
  useCreateReturn
};
//# sourceMappingURL=use-create-return.js.map
